<template>
  <div>
    <a-form-item class="btn-gropu-gps" :label="locationData.label" required v-bind="itemLayout || $store.state.base_itemLayout">
      <a-input-group compact>
        <a-form-item v-for="(item, index) of locationData.subList" :key="index">
          <a-input v-decorator="item.props" :placeholder="item.placeholder"/>
        </a-form-item>

        <a-form-item>
          <a-button @click="openModal" type="primary">点击定位</a-button>
        </a-form-item>
      </a-input-group>
    </a-form-item>

    <!--gps定位的弹窗-->
    <a-modal
      title=""
      :visible="visible"
      @ok="confirm"
      @cancel="visible=false"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      :width="1000"
      centered
      :maskClosable="false"
      :keyboard="false"
      :closable="false"
      :bodyStyle="{padding: '10px'}"
    >
      <div class="amap-box" id="container">
      </div>
      <div class="amap-search">
        <span>搜索：</span>
        <input id="tipinput" placeholder="请输入关键字"/>
      </div>
      <div class="output">
        <p>
          <span class="title">经纬度：</span>
          <span class="value">{{positionResult[inputKey.lat]}},{{positionResult[inputKey.lng]}}</span>
        </p>
        <p>
          <span class="title">地址：</span>
          <span class="value">{{positionResult[inputKey.address]}}</span>
        </p>
        <p>
          <span class="title">最近的POI：</span>
          <span class="value">{{positionResult.PIO}}</span>
        </p>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'location',
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    lnglat: '',
    position: '',
    inputKey: {
      type: Object,
      default: () => {}
    },
    locationData: {
      type: Object,
      default: () => {}
    },
    itemLayout: {
      type: Object
    }
  },
  data () {
    return {
      location: '',
      visible: false,
      map: {},
      positionResult: {}
    };
  },
  mounted () {
  },
  methods: {
    openModal () {
      this.visible = true;
      this.initAMap();
    },
    confirm () {
      if (this.positionResult) {
        let inputVal = {...this.positionResult};
        let index = this.positionResult[this.inputKey.address].indexOf(this.position);
        if (index < 0) {
          this.$message.error('请选取区域范围内经纬度');
          return;
        }

        delete inputVal.PIO;
        for (let item in inputVal) {
          if (item === 'no_address') { // 当输入框不需要输入address时，key为no_address
            delete inputVal.no_address;
          }
        }
        this.form.setFieldsValue(inputVal);
        this.location = [inputVal[this.inputKey.lng], inputVal[this.inputKey.lat]];
      } else {
        this.$message.error('获取定位失败！');
      }
      this.map.destroy();
      this.visible = false;
    },
    /* 初始化地图 */
    initAMap () {
      this.$nextTick(() => {
        AMapUI.loadUI(['misc/PositionPicker'], (PositionPicker) => {
          this.map = new AMap.Map('container', {
            resizeEnable: true,
            zoom: 18,
            scrollWheel: true
          });

          if (this.location) {
            this.map.setCenter(this.location);
            this.location = '';
          } else if (this.position && typeof this.position === 'string') {
            this.map.setCity(this.position);
          }
          this.map.setZoom(18);
          // this.map.setBounds(this.map.getBounds());

          var positionPicker = new PositionPicker({
            mode: 'dragMap',
            map: this.map
          });
          positionPicker.on('success', (result) => {
            this.positionResult = {
              [this.inputKey.lat]: result.position.lat,
              [this.inputKey.lng]: result.position.lng,
              [this.inputKey.address]: result.address,
              PIO: result.nearestPOI
            };
          });
          positionPicker.on('fail', (result) => {
            this.positionResult = {
              [this.inputKey.lat]: result.position.lat,
              [this.inputKey.lng]: result.position.lng,
              [this.inputKey.address]: result.address,
              PIO: result.nearestPOI
            };
          });
          positionPicker.start();
          this.map.panBy(0, 1);

          this.map.addControl(new AMap.ToolBar({
            liteStyle: true
          }));

          var auto = new AMap.Autocomplete({input: 'tipinput'});
          var placeSearch = new AMap.PlaceSearch({map: this.map});

          AMap.event.addListener(auto, 'select', function (e) {
            placeSearch.setCity(e.poi.adcode);
            placeSearch.search(e.poi.name);
          });
        });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/package/location.vue